import { Component, type ErrorInfo, type ReactNode } from 'react';
import { zhTW } from '../i18n/zh-TW';

/**
 * Last line of defence around the whole tree.
 *
 * Deliberately not localised through the context: if the i18n provider is what
 * crashed, reading from it here would crash again. The default catalogue is
 * imported directly instead.
 */
interface State {
  error: Error | null;
}

export class ErrorBoundary extends Component<{ children: ReactNode }, State> {
  override state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  override componentDidCatch(error: Error, info: ErrorInfo): void {
    // Cloud Logging picks this up from the browser only if a reporter is wired
    // in; until then the console is where a bug report comes from.
    console.error('journalmap: unhandled render error', error, info.componentStack);
  }

  override render(): ReactNode {
    const { error } = this.state;
    if (!error) return this.props.children;

    return (
      <div className="centre-state">
        <h1 className="page__title">{zhTW['crash.title']}</h1>
        <p className="muted">{zhTW['crash.body']}</p>
        <p className="mono faint">{error.message}</p>
        <button type="button" className="button" onClick={() => window.location.reload()}>
          {zhTW['crash.reload']}
        </button>
      </div>
    );
  }
}
